<template>
  <div>
    <div class="mb-4">
      <div class="location-home pt-2.5">
        <!-- <h3 class="fsize20 font-semibold">Home / {{ get_location }}</h3>
         -->
        <h3 class="fsize30 text-primary font-semibold mb-4" v-if="!cardView">
          {{ this.serviceName }}
        </h3>
        <h3 class="fsize30 font-semibold text-primary mb-4" v-if="cardView">
          Service Provider
        </h3>
      </div>

      <div class="flex ml-auto lg:mt-0 md:mt-0 mt-4">
        <!-- <b-form-input
          id="input-default"
          label-size="large"
          class=""
        ></b-form-input> -->

        <div class="search">
          <base-button
            @click="handleRoute('request-form', 'request-for-service')"
            type="primary"
            class="search-clr-btn ml-2"
          >
            <span> Request for Service </span>
          </base-button>
          <base-button
            @click="handleService"
            type="primary"
            class="search-clr-btn ml-2"
          >
            <span> Know Your Service Provider </span>
          </base-button>
        </div>
      </div>
    </div>
    <div class="" v-show="!cardView">
      <!-- <img
        src="../../../assets/images/nodata.svg"
        alt="image"
        class="sprovider-img mx-auto"
      /> -->

      <p>
        <span class="font-bold text-primary"> Service Description:</span> Are
        you constantly wondering how to better support your loved ones? Do you
        sometimes feel lost or overwhelmed by the challenges of caregiving?
        You're not alone. Caregiving is a demanding role that can leave us
        feeling anxious and confused.
      </p>
      <br />

      <div class="text-777777 font-normal mb-2">
        <span class="font-bold text-primary">
          Why Consider Caregiver Coaching:
        </span>
        Caregiver coaching provides a unique opportunity to enhance your
        caregiving experience.
      </div>
      <ul class="list-decimal font-bold mb-4">
        <li class="text-777777 font-normal">
          <span class="font-bold text-primary"> Guidance and Support: </span>
          Receive one-on-one coaching tailored to your caregiving needs,
          providing valuable guidance and support.
        </li>

        <li class="text-777777 font-normal">
          <span class="font-bold text-primary"> Building Resilience: </span>
          Learn strategies to build resilience, enabling you to navigate
          caregiver stress with greater ease.
        </li>

        <li class="text-777777 font-normal">
          <span class="font-bold text-primary"> Emotional Mastery: </span>
          Develop emotional mastery to cope with compassion fatigue and process
          complex emotions effectively.
        </li>
      </ul>

      <p>
        <span class="text-primary font-bold"> Our Service:</span> At Caregiver
        Saathi, we understand the challenges you face. That's why we offer
        personalized coaching for family caregivers like you. Our coaching is
        designed to empower you, enhance your emotional well-being, and provide
        the guidance you need on your caregiving journey.
        <br />
      </p>
      <p class="mt-4">
        <span class="font-bold text-primary mt-2">For Whom:</span> Family
        caregivers seeking guidance and emotional support.
      </p>
      <h6 class="mt-3 text-primary fsize16 font-bold">Why Choose Us:</h6>
      <ul class="list-decimal font-bold mb-4">
        <li class="text-777777 font-normal mb-2">
          Tailored coaching for your unique caregiving challenges.
        </li>

        <li class="text-777777 font-normal mb-2">
          Build resilience and emotional mastery.
        </li>

        <li class="text-777777 font-normal mb-2">
          Navigate caregiver stress with confidence.
        </li>

        <li class="text-777777 font-normal mb-2">
          Process complex emotions effectively.
        </li>
      </ul>
      <p class="mb-2 underline">Empower Your Caregiving Journey Today!</p>

      <p class="mb-2 text-gray">
        Price: Affordable coaching sessions starting at
        <span class="text-dark font-semibold"
          >INr 4000/ session + 18% GST.</span
        >
      </p>
      <p class="mb-2 text-gray">
        For 5 or more sessions:<span class="text-dark font-semibold">
          INR 3500/ session + 18% GST</span
        >
      </p>
    </div>
    <Bcard class="lg:mt-20 md:mt-20 mt-12" v-show="cardView" />
  </div>
</template>

<script>
import { mapState } from "vuex";
import Bcard from "./Bcard.vue";

export default {
  props: ["location"],
  components: {
    Bcard,
  },
  data() {
    return {
      dataFound: false,
      serviceName: "",
      cardView: false,
    };
  },
  computed: {
    ...mapState("respitecare", {
      get_location: "get_location",
    }),
    ...mapState("respitecare", {
      get_volunteer_by_location: "get_volunteer_by_location",
    }),
    ...mapState("auth", ["user"]),
  },
  methods: {
    async handleService() {
      // this.$router.push({ name: 'product-services',query:{scroll:true} });
      // let urlToRedirect = `${window.location.origin}/product-services`;
      // localStorage.setItem("bookService", true);
      // window.open(urlToRedirect, "_blank");
      if (Object.keys(this.user).length === 0) {
        this.$router.push({ name: "signin" });
        this.$swal.fire({
          title: "",
          text: "Please login to access this content",
          icon: "warning",
          confirmButtonColor: "#830c81",
          showCancelButton: false,
        });
        return;
      }
      this.userDetails = sessionStorage.getItem("token");
      try {
        // if (this.userDetails === null) {
        //   this.$swal
        //     .fire({
        //       title: "Login!",
        //       text: "Please login to continue",
        //       icon: "info",
        //       confirmButtonText: "Okay",
        //       confirmButtonColor: "#830c81",
        //       showCancelButton: false,
        //     })
        //     .then((result) => {
        //       return this.$router.push({ name: "signin" });
        //     });
        //   return;
        // }
        this.cardView = !this.cardView;
        let payload = {
          service: this.serviceName,
        };
        let data = await this.$store.dispatch(
          "respitecare/getVolunteerByService",
          payload
        );
      } catch (error) {
        console.log(error);
      }
    },
    handleRoute(name, params) {
      // if (Object.keys(this.user).length === 0) {
      //   this.$router.push({ name: "signin" });
      //   this.$swal.fire({
      //     title: "",
      //     text: "Please login to access this content",
      //     icon: "warning",
      //     confirmButtonColor: "#830c81",
      //     showCancelButton: false,
      //   });
      //   return;
      // }
      this.$router.push({ name: name, params: { pathName: params } });
    },
  },
  async mounted() {
    if (this.get_volunteer_by_location.length > 0) {
      this.dataFound = true;
    }
    this.serviceName = this.$route.query.service;
    // console.log(this.serviceName);
  },
};
</script>

<style>
.search-clr-btn {
  color: #f8f9fe;
  background-color: #4f0a4b;
}
.fsize30 {
  font-size: 30px;
}
</style>
